import React from "react";
import { useParams } from "react-router";
//Limitless imports
import { SettingsTabs, ProfileDetails, Security } from "@limitless/portal";
import { useExpertProfileContext } from "@limitless/expert";
import { POLICY_PAYMENTS_ACCESS } from "@limitless/portal/utils";
import AppSettings from "./tabs-content/AppSettings";
import Address from "./tabs-content/Address";
import Payment from "./tabs-content/Payment";

const Settings = () => {
    const params = useParams();
    const { canUserAccess } = useExpertProfileContext();

    const hasPaymentAccessForProfileTab = canUserAccess(POLICY_PAYMENTS_ACCESS);

    const EXPERT_SETTINGS_TABS_LABEL = [
        { label: "Profile Details", id: "profileDetails" },
        hasPaymentAccessForProfileTab ? { label: "Address", id: "address" } : null,
        hasPaymentAccessForProfileTab ? { label: "Payment", id: "payment" } : null,
        { label: "Security", id: "security" },
        { label: "App Settings", id: "appSettings" }
    ].filter(i => i !== null);

    const SETTINGS_TAB = [
        <ProfileDetails isExpertApp key={1} />,
        hasPaymentAccessForProfileTab ? <Address key={2} /> : null,
        hasPaymentAccessForProfileTab ? <Payment key={3} /> : null,
        <Security key={4} />,
        <AppSettings key={5} />
    ].filter(i => i !== null);

    return (
        <SettingsTabs
            tabsLabels={EXPERT_SETTINGS_TABS_LABEL}
            tabsContent={SETTINGS_TAB}
            selectedTab={parseInt(params.selectedSettingsItem) || 0}
        />
    );
};

export default Settings;
